import api from '../utils/api'


export const axios_verifyVoucher=(data, callback, errorCallback)=>{

    api
    .post(`/voucher/verify-voucher?voucher_id=${data}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    },
    
    )
    .then((response) => callback(response))
    .catch(error => {
        console.log("Oops! Something went wrong.", error);
        // toast.error(error.response.data.message,{position:toast.POSITION.TOP_RIGHT})
        errorCallback(error)
    });  
}


//update game status 1= Visit, 2=Password Verify, 3= game won
export const axios_updateVoucherStatus=(data)=>{
    api.post(`/voucher/update-status`, data,{
        header: {
            'Content-Type': 'application/json'
        }
    })
    .then((response)=>{})
    .catch(error => {
        console.log("Oops! something went wrong.", error)
    })
}